import React, { useContext } from 'react'
import { Hydrator } from '@usap/core'
import { LocalContext } from '../../../../helpers/useLocalContext'
import Article from './Article.loadable'

const ArticleLazyLoader = props => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  return (
    <Hydrator
      Component={Article}
      lazy={!isBot}
      {...props}
    />
  )
}

export default ArticleLazyLoader
